// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#partners {\n   background-color: #F5F5F5;\n   padding-bottom: 84px;   \n}\n.marginTop70{\n   margin-top: 70px;\n}\n", "",{"version":3,"sources":["webpack://src/css/partner.css"],"names":[],"mappings":"AAAA;GACG,yBAAyB;GACzB,oBAAoB;AACvB;AACA;GACG,gBAAgB;AACnB","sourcesContent":["#partners {\n   background-color: #F5F5F5;\n   padding-bottom: 84px;   \n}\n.marginTop70{\n   margin-top: 70px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
